import React from 'react'
import root from '../shared/utils'
import {getOrdinalDate} from '../shared/enums/date-parser'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import { Modal } from 'react-bootstrap'
import TitledBulletPoint from '../shared/titled-bullet-point'
import moment from 'moment'

export default React.createClass({

  render: function () {
    let serverPath = root + '/common/latest/images/consumer'
    let calendarIcon = serverPath + '/status-icons/SCHEDULED-flat.png'
    let weeklyBlue = serverPath + '/order-process-icons/weekly-blue.png'
    let oneStar = serverPath + '/order-process-icons/one-star-blue.png'
    let schedule = serverPath + '/order-process-icons/checkmark-blue.png'
    if (this.props.modalCard) {
      let subTasks = []
      let intervalDisplay = this.props.modalCard.intervalDisplay.title
      let serviceLevelDisplay = this.props.modalCard.packageDisplay.title
      let scheduleDisplay = this.props.modalCard.scheduleDisplay.title
      let date
      if (this.props.modalCard.millisDate) {
        date = getOrdinalDate(this.props.modalCard.millisDate)
      } else if(this.props.modalCard.estimatedStartTime) {
        date = getOrdinalDate(this.props.modalCard.estimatedStartTime)
      }else {
        date = getOrdinalDate(this.props.modalCard.eventDate * 24 * 60 * 60 * 1000 + 86400000)
      }
      let iconTypeInfo = getTaskTypeIconParser(this.props.modalCard.taskType)
      let taskTitle = iconTypeInfo.prettify
      let taskIcon = iconTypeInfo.iconsrc
      let costOfService
      if(this.props.actualCost) {
        costOfService = this.props.actualCost
      }
      else {
        costOfService = this.props.modalCard.cost
      }
      let taskID = this.props.modalCard.taskId

      for (let i = 0; i < this.props.modalCard.subTasks.length; i++) {
        let task = this.props.modalCard.subTasks[i]

        let task1Html = <TitledBulletPoint description={task.helpText} title={task.name} />
        subTasks.push(
          <div key={'subTask' + i} className='row'>
            <div className='col-xs-12'>
              {task1Html}
            </div>
          </div>
        )
      }

        let buttonA
        let buttonB = ''
      if(this.props.modalCard){
        for(let i = 0; i< this.props.modalCard.mobileJobButtons.length; i++) {
          if(this.props.modalCard.mobileJobButtons[i].buttonDisplay.includes('Skip')) {
            const showSkip = this.props.modalCard.intervalDisplay.taskDisplayOption !== 'ONE_TIME'
            buttonB = showSkip
              ? <div className='col-xs-12 col-md-6 text-center pull-down-xs-1 pull-down-sm-0'>
                  <button className='btn btn-info btn-sm modal-button' onClick={this.props.showSkipJob}>{this.props.modalCard.mobileJobButtons[i].buttonDisplay}</button>
                </div>
              : ''
          }
        }
          if(buttonB === ''){
              buttonA = <div className='col-xs-12 col-md-12 text-center'>
                        {buttonA}
                        </div>
          }
          else{
            buttonA = <div className='col-xs-12 col-md-6 text-center'>
                        {buttonA}
                        </div>
          }
      }

      let taskButton = 'Change Task Options';
      if(moment(this.props.modalCard.estimatedStartTime).isBefore(moment())){
        taskButton = 'Task Options'
      }


      return (

        <div>
          <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='my-modal-size'>
            <Modal.Header closeButton>
              <div className={'task-type center no-text img-responsive center-block pull-down-xs-3'}>
                <div className={`${taskIcon}-icon`}/>
              </div>
              <h2 className='text-center'>{taskTitle}</h2>
              <br/>
              <div className='text-center row' style={{padding: '20px 20px'}}>
                <div className='modal-icon-head'>
                  <img className='modal-sub-icon' style={{marginTop: 3}} src={calendarIcon} alt='' />
                  <h5 className='pull-left modal-sub-text' style={{fontSize: 24}}>Next Scheduled Service Date:
                    <b style={{fontWeight: 400}} className='spacer'>
                      {date}
                    </b>
                  </h5>
                </div>
                <div>
                <p dangerouslySetInnerHTML={{ __html: this.props.description }}></p>
                </div>
              </div>
              <div className='row modal-buttons-container'>
                {buttonA}
                {buttonB}
              </div>
              <div style={{margin: 25, marginTop: 30, padding: 30, backgroundColor: '#E1E1E1'}}>
                  <h3 style={{textAlign: 'center'}}>Your {taskTitle} Task Details</h3>
                  <div className='row pull-down-sm-2'>
                    <div className='col-sm-6'>
                        <div style={{height: 40}}>
                          <img className='pull-left' role='presentation' src={weeklyBlue} style={{width: '25px', height: '25px', marginRight: 10}} />
                          <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Frequency: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{intervalDisplay}</span></h6>
                        </div>
                        <div style={{height: 40}}>
                          <img className='pull-left' role='presentation' src={oneStar} style={{width: '25px', height: '25px',marginRight: 10}} />
                          <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Service Plan: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{serviceLevelDisplay}</span></h6>
                        </div>
                        <div style={{height: 30}}>
                          <img className='pull-left' role='presentation' src={schedule} style={{width: '25px', height: '25px',marginRight: 10}} />
                          <h6 className='baseline-color' style={{textAlign: 'left', padding: '0 0 0 10px'}}>Schedule: <span style={{fontWeight: 400}} className='cerulean-blue-color'>{scheduleDisplay}</span></h6>
                        </div>
                        <div>
                          <hr style={{borderTopColor: '#818181'}} />
                        </div>
                        <div style={{height: 30}}>
                          <h6 className='baseline-color'>Price:<span style={{fontWeight: 400}} className='cerulean-blue-color spacer'>${costOfService} per service</span></h6>
                        </div>
                        <div style={{height: 30}}>
                          <h6 className='baseline-color'>Order #: <span style={{fontWeight: 400}} className='cerulean-blue-color spacer'>{taskID}</span></h6>
                        </div>
                        <div>
                          <hr style={{borderTopColor: '#818181'}} />
                        </div>
                        <div style={{height: 30}}>
                          <h6 className='pull-left' style={{textDecoration: 'underline'}}><a onClick={() => this.props.showEditTask(this.props)}>{taskButton}</a></h6>
                        </div>
                    </div>
                    <div className='col-sm-6 pull-down-xs-2 pull-down-sm-0'>
                      <div className='panel panel-default' style={{border: 0, boxShadow: 'none'}}>
                        <div className='panel-body text-center'>
                          <h5>Your service includes</h5>
                        </div>
                        <div className='panel-body text-left'style={{marginLeft: 20}}>
                          {subTasks}
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </Modal.Header>
          </Modal>
        </div>
      )
    } else {
      return <div />
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/task-details-modal.jsx